import { getAllUserRolePending, getAllUserRoleSuccess, getAllUserRoleFail } from "./allUserRoleSlice";
import { fetchAllUserRole } from "../../../api/userApi";

export const getAllUserRole = () => async(dispatch) => {
    try {
         //call the api
        dispatch(getAllUserRolePending());
        const result = await fetchAllUserRole();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);
        
console.log('allRoleData '+myJSON);
//console.log('alluserData 1  '+myJSON.user);
const myObj =JSON.parse(myJSON);
const roledetails =JSON.parse(JSON.stringify(myObj.userroles));
const roledetails1 =JSON.parse(JSON.stringify(roledetails));
//console.log('us '+roledetails1[0].id);
//console.log('getuserpending '+result.userroles[0].id);
/* console.log('getuserpending user '+result.user[0].firstName);
console.log('getuserpending fname '+result.lastName);
console.log('getuserpending lname '+result.user.lastName); */
//console.log('check user profile out if');
        if(roledetails){
        //console.log('check user profile');
            return dispatch(getAllUserRoleSuccess(roledetails));
        }
        dispatch(getAllUserRoleFail("User is not found"));

       
    } catch (error) {
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getAllUserRoleFail(err.msg));
       

    }
}